// ko.ts — 한국어 문구
export const ko = {
      _l: "ko",
      eyebrow: "MolePin 에어드랍 · 무료 MOL",
      h1: '거래소에서 BNB 받은 적 있다면<br><span class="g">MOL 1만 개가 무료.</span>',
      lede: "거래소 입금 <em>1건당 10,000 MOL</em>(최대 10건). <em>X 팔로우 10,000 MOL</em> + <em>텔레그램 10,000 MOL</em> — 입금이 없어도 <em>20,000 MOL</em>. 지갑당 최대 <em>120,000 MOL</em>.",
      notConnected: "굴맥에 묶인 지갑 없음",
      exchLabel: "굴맥 연결 거래소:",
      fcfsLabel: "입장한 데너",
      railTitle: "굴맥의 인장",
      sealDepName: "입금", sealDepDesc: "거래소가 내 지갑으로 BNB(또는 BNB체인 토큰)를 보냈다면. 입금 1건당 10,000 MOL, 최대 10건.",
      sealDepBtn: "입금 증명하기",
      proveMore: function (n: number) { return "추가 등록 (" + n + "/10)"; },
      proveFull: "10건 모두 청구 완료",
      sealXName: "𝕏 팔로우", sealXDesc: "𝕏에서 MolePin 팔로우 → 10,000 MOL. 딱 한 번만.",
      sealXBtn: "𝕏 연결",
      sealTgName: "텔레그램", sealTgDesc: '그룹에 "MolePin Up" 또는 "MolePin 화이팅" 적기 → 10,000 MOL. 딱 한 번만.',
      sealTgBtn: "굴 열기",
      stLocked: "미봉인", stDone: "봉인됨",
      digTitleLocked: "흙더미는 닫혀 있다", digSubLocked: "세 인장을 모두 모으면 땅이 갈라지고 MOL을 캘 수 있다.",
      digBtnLocked: "인장 미완성",
      digTitleOpen: "굴맥이 열린다", digSubOpen: "세 인장이 금빛으로 타오른다. 땅을 내리쳐 계약이 빚진 것을 가져가라.",
      digBtnOpen: "MOL 캐기",
      modalTitle: "입금 증명",
      eligibleNote: "⚠️ 거래소(Binance, Coinbase, 빗썸 등)에서 내 지갑으로 직접 받은 <b>0.001 BNB 이상</b>의 입금만 인정됩니다. 개인 지갑·DEX·타인에게서 받은 것은 인정되지 않습니다.",
      modeScan: "자동 스캔", modeTx: "txid 입력",
      scanHint: function (ex: string) { return "지갑에서 " + ex + " 발 BNB 입금을 찾습니다."; },
      scanBtn: "내 입금 검색",
      txHint: "BNB 입금 tx 해시를 줄바꿈으로 최대 10개 붙여넣으세요.",
      txGuideTitle: "📖 TX 해시(Hash) 찾는 법",
      txGuideHint: "BscScan에서 내 지갑의 거래 내역을 열고, From이 거래소(Binance 등)이고 초록색 IN 배지가 있는 행을 찾아 Transaction Hash를 복사하세요.",
      tryTxidTitle: "자동으로 안 찾아지나요?",
      tryTxidBody: "이용하신 거래소 핫월렛이 아직 목록에 없을 수 있어요. 입금 TX 해시를 직접 붙여넣으면 됩니다 — BscScan에서 거래소 입금(초록 IN)을 찾아 해시를 복사하세요.",
      tryTxidBtn: "TX 해시 직접 입력",
      verifyTxBtn: "txid 검증",
      claimBtn: "MOL 캐기",
      loreTitle: "굴맥",
      loreBody: "<strong>엘도라시아</strong>, 17개 골든 두더지 부족의 지하 왕국. 열여섯이 사라진 뒤, 마지막 후계자 <strong>몰핀</strong>이 다시 굴을 판다. <strong>데너</strong>는 굴맥의 수호자로 그 곁에 선다. 인장은 굴맥이 당신이 진짜임을 아는 방식이다.",
      trust: "거래소와 무관한 몰핀 커뮤니티 캠페인입니다. 자격은 공개 온체인 데이터에만 근거합니다. 서명은 지갑 소유권 증명용이며 자산 전송·approve는 요청하지 않습니다. 투자 권유가 아닙니다.",
      dexMsg: "<b>지갑에 이름</b>을 — 0x 대신 읽기 쉬운 이름으로. DEXignation 오픈.",
      dexCta: "이름 만들기",
      linksTitle: "굴맥의 문 & 동맹",
      linksSub: "BNB를 옮길 거래소를 열거나, 동맹 사이트를 방문하세요.",
      linksExch: "거래소",
      linksPartner: "제휴 사이트",
      linksCommunity: "커뮤니티",
      linksChannelTag: "채널 · 공지",
      linksGroupTag: "그룹 · 인장 획득",
      linksDigmolTag: "데너 / 분배자",
      linksDexTag: "제휴",
      inappMsg: "이 인앱 브라우저에서는 지갑이 작동하지 않습니다. 외부 브라우저로 열어주세요.",
      inappBtn: "브라우저로 열기",
      inappManual: "우측 상단 ⋯ 메뉴 → \"다른 브라우저로 열기\"를 눌러주세요.",
      sealCount: function (n: number) { return n + " / 3"; },
      validCount: function (n: number) { return "입금 " + n + "건 검증"; },
      depositsFound: function (n: number, bnb?: string) { return "입금 " + n + "건" + (bnb ? " (" + bnb + " BNB)" : "") + " 확인 ✓"; },
      willGetMol: function (m: string) { return "→ " + m + " MOL 받게 됩니다"; },
      noDepositsBig: "BNB 입금 0건",
      alreadyClaimed: "이미 청구됨",
      alreadyClaimedBig: "이미 청구된 입금",
      alreadyClaimedNote: "이 입금은 이미 청구에 사용되었습니다",
      myTxTitle: "이미 등록한 입금",
      myTxConfirmed: "청구됨",
      myTxPending: "처리 중",
      noValid: "유효한 거래소 입금이 없습니다",
      claimAmt: function (m: string) { return m + " MOL 캐기"; },
      noGas: "claim하려면 가스비용 BNB가 조금 필요합니다. BNB를 충전한 뒤 다시 시도하세요.",
      errTxidUsed: "이미 청구된 입금입니다.",
      errBadSigner: "서명 오류입니다. 새로고침 후 다시 시도해주세요.",
      errExpired: "요청이 만료되었습니다. 다시 시도해주세요.",
      errWalletCap: "이 지갑은 청구 한도(10건)에 도달했습니다.",
      errClaimerLimit: "에어드랍이 마감되었습니다 (선착순 10,000명).",
      errPaused: "청구가 일시 중지되었습니다.",
      errNothing: "청구할 내역이 없습니다.",
      errTransferFail: "토큰 전송에 실패했습니다. 잠시 후 다시 시도해주세요.",
      dug: function (m: string) { return "금맥을 찾았다 — " + m + " MOL 획득."; },
      needConnect: "먼저 굴맥에 지갑을 묶으세요.",
      overLimit: "txid는 최대 10개.",
      fcfsClosed: "마감", fcfsRemaining: function (r: number) { return "남은 자리 " + r; }, fcfsMax: "시험 마감",
      errClosed: "10,000 데너 자리가 모두 찼습니다.",
      errCap: "이 지갑은 이미 10건을 캤습니다.",
      xBound: function (h: string) { return "𝕏 연결됨: @" + h; },
      tgHelp: "1. 그룹 입장  2. \"MolePin Up\" 또는 \"MolePin 화이팅\" 적기  3. 완료.",
      openTg: "텔레그램 열기", copyPhrase: "\"MolePin Up\" 복사", phraseCopied: "복사됨!",
      errNoMM: "MetaMask가 필요합니다.", errNoCB: "Coinbase Wallet이 필요합니다.", cancelled: "취소됨.",
      connTimeout: "MetaMask 응답이 없습니다. 다시 연결을 시도해주세요.",
      connecting: "MetaMask 연결 중… 앱에서 승인 후 여기로 돌아오세요.",
      cancel: "취소",
      copyAddr: "클릭하면 전체 주소 복사", copied: "✓ 복사됨!",
      disconnect: "연결 해제",
      donateTitle: "후원",
      donateNote: "이더리움 · BNB 체인 · 폴리곤",
      donateWarn: "위 네트워크로만 보내주세요. 다른 네트워크로 전송하면 복구가 불가능할 수 있습니다.",
      donateCopied: "주소가 복사되었습니다",
      wrongChainWarn: "네트워크가 다릅니다. BNB 스마트 체인으로 전환하세요.",
      switchChainBtn: "네트워크 전환",
      wrongChainAlert: "BNB 스마트 체인 네트워크로 전환해주세요.",
      wrongChainRejected: "네트워크를 전환해야 MOL을 캘 수 있습니다.",
      bonusClaim: "10,000 MOL 받기",
      bonusClaiming: "서명 요청 중…",
      bonusPending: "지급 처리 중…",
      bonusReceived: "✓ 수령 완료",
      bonusDone: "10,000 MOL을 받았습니다!",
      bonusAlready: "이미 수령한 보너스입니다.",
      bonusNeedSeal: "먼저 인장을 획득해주세요.",
      bonusCapReached: "청구 한도에 도달했습니다.",
      xErrDup: "이 𝕏 계정은 이미 다른 지갑에서 인장을 받았습니다. X 계정 하나당 지갑 하나만 가능합니다.",
      xErrFollow: "팔로우 확인에 실패했습니다. 𝕏에서 MolePin을 팔로우한 뒤 다시 시도해주세요.",
      xErrGeneric: "𝕏 인증에 실패했습니다. 잠시 후 다시 시도해주세요.",
      rsnBelowMin: "최소 0.001 BNB 이상이어야 합니다",
      rsnNotExchange: "거래소에서 보낸 입금이 아닙니다",
      rsnRecipient: "연결한 지갑으로 받은 입금이 아닙니다",
      rsnNotFound: "해당 트랜잭션을 찾을 수 없습니다",
      rsnNotConfirmed: "아직 확정되지 않은 트랜잭션입니다",
      rsnUnknown: "인정되지 않는 입금입니다",
};
export default ko;